import { RootStoreModel } from "@redux/reducers";
import {
  Button, Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Empty,
  Row,
  Space,
  Table
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
// 引入 ECharts 主模块
import * as echarts from 'echarts';
import dayjs from 'dayjs';
import { getAssetsStatistic, getStatisticExcel } from "../../axios/api.asset";
// // 引入柱状图
import { SettingOutlined, UploadOutlined } from '@ant-design/icons';
import { PieChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/markLine';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/tooltip';

import { t } from "i18next";
import { Translation } from "react-i18next";

const CheckboxGroup = Checkbox.Group;
interface propsModel extends RouteComponentProps<any, any, any> {
  account: any,
  isLogin: boolean
}
interface stateModel {
  organizationAssetCalDtos: any[],
  tagAssetCalDtos: any[]
  assetMonthCalDtos: {
    datas: any[],
    names: any[]
  },
  assetMonthDetailCalDtos: any[],
  isRegis: boolean,
  startTime: any,
  endTime: any,
  tableDropdownVisible: boolean,
  tableColumns: any[],
  tableCheckColumes: string[]
}
const dateFormat = 'YYYY/MM';
const searchDateFormat = 'YYYYMM';
const mapStatetoProps = (state: RootStoreModel) => ({
  account: state.userState.account,
  isLogin: state.userState.tokenSuccess
});
const tableColumnTem = [

  {
    title: '时间',
    dataIndex: 'month',
    key: 'month'
  },
  {
    title: '资产名称',
    dataIndex: 'assetName',
    key: 'assetName'
  },
  {
    title: '数量',
    dataIndex: 'deviceCount',
    key: 'deviceCount'
  },
  {
    title: '来源',
    dataIndex: 'source',
    key: 'source'
  },
  {
    title: '摊销单价',
    dataIndex: 'amount',
    key: 'amount'
  },
  {
    title: '摊销总成本',
    dataIndex: 'totalAmount',
    key: 'totalAmount'
  },
]

class AssetAllocation extends React.Component<propsModel, stateModel> {

  constructor(props: propsModel) {
    super(props);
    this.state = {
      organizationAssetCalDtos: [],
      tagAssetCalDtos: [],
      assetMonthCalDtos: {
        datas: [],
        names: []
      },
      assetMonthDetailCalDtos: [],
      isRegis: false,
      startTime: dayjs().subtract(14, 'day'),
      endTime: dayjs(),
      tableDropdownVisible: false,
      tableColumns: tableColumnTem,
      tableCheckColumes: tableColumnTem.map(e => { return e.key })
    };

  }
  getStartDate(num: number) {
    var nowDate = new Date();
    nowDate.setDate(nowDate.getDate() - num)
    return nowDate;
  }
  getInfo = (startTime: any = null, endTime: any = null) => {

    var arg = {
      beginDate: startTime ? startTime.format(searchDateFormat) : this.state.startTime.format(searchDateFormat),
      endDate: endTime ? endTime.format(searchDateFormat) : this.state.endTime.format(searchDateFormat),
    }
    getAssetsStatistic(arg).then((res) => {
      console.log("getAssetsStatistic", res)
      var tmpOrganization: { value: any; name: any; }[] = [];
      var tmpTag: { value: any; name: any; }[] = [];
      var tmpAssetMonth: any = {datas: [], names: []};
      res?.organizationAssetCalDtos?.forEach((ele: any) => {
        tmpOrganization.push({ value: ele?.amount, name: ele?.organizationName })
      });
      res?.tagAssetCalDtos?.forEach((ele: any, i: number) => {
        tmpTag.push({ value: ele?.amount, name: ele?.tagValue })
      });
      res?.assetMonthCalDtos?.forEach((ele: any) => {
        tmpAssetMonth.datas.push(ele?.amount)
        tmpAssetMonth.names.push(ele?.month)
      });

      this.setState({
        organizationAssetCalDtos: tmpOrganization,
        tagAssetCalDtos: tmpTag,
        assetMonthCalDtos: tmpAssetMonth,
        assetMonthDetailCalDtos: res?.assetMonthDetailCalDtos
      });
      this.updateTable();
    });


  }
  tableColumnsChange = (list: any) => {
    var tabs = tableColumnTem.filter(item => {
      return list.findIndex((c: any) => c == item.key) != -1;
    })
    this.setState({ tableColumns: tabs, tableCheckColumes: list });

  }
  updateTable = (allocationTitlesMap: any={}) => {

    if (Object.keys(allocationTitlesMap).length > 0) {
      localStorage.setItem("allocationTitlesMap", JSON.stringify(allocationTitlesMap));
    }
    var titles: any = localStorage.getItem("allocationTitlesMap");
    if (titles) {
      titles = JSON.parse(titles);
    }

    let ec = echarts as any;
    ec?.use([PieChart, GridComponent]);
    // 初始化
    // if (document.getElementById('organizationAssetCalDtos')) {
    //   var organizationEchart = echarts.init(document.getElementById('organizationAssetCalDtos') as HTMLDivElement);
    //   organizationEchart.setOption({
    //     title: {
    //       text: allocationTitlesMap.lowerLevelOrganization || titles.lowerLevelOrganization || '按部门统计',
    //       left: 'left'
    //     },
    //     tooltip: {
    //       trigger: 'item'
    //     },
    //     legend: {
    //       left: 'right',
    //       bottom: "10%",
    //       orient: 'vertical',
    //     },
    //     series: [
    //       {
    //         name: '设备类型',
    //         type: 'pie',
    //         radius: ['30%', '50%'],
    //         avoidLabelOverlap: false,
    //         data: this.state.organizationAssetCalDtos,
    //         emphasis: {
    //           itemStyle: {
    //             shadowBlur: 10,
    //             shadowOffsetX: 0,
    //             shadowColor: 'rgba(0, 0, 0, 0.5)'
    //           }
    //         }
    //       }
    //     ]
    //   })
    // }
    if (document.getElementById('tagAssetCalDtos')) {
      var tagEchart = echarts.init(document.getElementById('tagAssetCalDtos') as HTMLDivElement);
      tagEchart.setOption({
        title: {
          text: allocationTitlesMap.tagDistribution || titles.tagDistribution || t('按设备组统计'),
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: 'right',
          bottom: "10%",
          orient: 'vertical',
        },
        series: [
          {
            name: '设备组',
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            data: this.state.tagAssetCalDtos,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    }
    if (document.getElementById('assetMonthCalDtos')) {
      var assetMonthCalDtos = echarts.init(document.getElementById('assetMonthCalDtos') as HTMLDivElement);
      assetMonthCalDtos.setOption({
        title: {
          text: allocationTitlesMap.assertDistribution || titles.assertDistribution || '按月统计',
          left: 'left'
        },
        xAxis: {
          type: 'category',
          data: this.state.assetMonthCalDtos.names
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.state.assetMonthCalDtos.datas,
            type: 'bar'
          }
        ]
      })
    }
    window.onresize = () => {
      //organizationEchart?.resize();
      tagEchart?.resize();
      assetMonthCalDtos?.resize();
    }

  }
  searDateChange = (date: any) => {

    this.getInfo(date[0], date[1]);
  }
  componentDidMount() {
    if (this.props.isLogin) {
      this.getInfo();
    }

  }
  exportExcelClick = () => {
    var arg = {
      beginDate: this.state.startTime.format(searchDateFormat),
      endDate: this.state.endTime.format(searchDateFormat),
    }
    getStatisticExcel(arg).then((blob) => {
      console.log(blob);
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download =  arg.beginDate+"_"+arg.endDate+".xls"; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    });
  }
  componentDidUpdate(prevProps: propsModel) {
    if (this.props.isLogin != prevProps.isLogin) {
      this.getInfo();
    }
  }

  render() {
    const {
      startTime,
      endTime,
      assetMonthDetailCalDtos,
      tableDropdownVisible,
      tableColumns,
      tableCheckColumes
    } = this.state;
    const { isLogin } = this.props;
    return (
      <Translation>{t => {
        var allocationTitlesMap = {
          lowerLevelOrganization: t("按部门统计"),
          tagDistribution: t("按设备组统计"),
          assertDistribution: t("按月统计"),
        }
        this.updateTable(allocationTitlesMap);

        return (
          <div className="overviewBox" >
            {isLogin && (
              <Row justify="center">
                <div className="borderBox">
                  <Row className="mb-3">
                    <Col>
                      {t("时间段")}:
                      <DatePicker.RangePicker
                        style={{ marginLeft: 16 }}
                        defaultValue={[startTime, endTime]}
                        format={dateFormat}
                        picker="month"
                        onChange={this.searDateChange}
                      />
                    </Col>
                  </Row>
                </div>
                <Row className="borderBoxnotBg"  >
                  <Col span={24}>
                    <Row gutter={[16, 16]} >
                      {/* <Col span={12}><div id="organizationAssetCalDtos" className="homeContentTableBox"></div></Col> */}
                      <Col span={24}><div id="tagAssetCalDtos" className="homeContentTableBox"></div></Col>
                      <Col span={24}  >
                        <div id="assetMonthCalDtos" className="homeContentTableBox"></div>
                      </Col>
                      <Col span={24}>
                        <Row>
                          <Col className="ms-auto" style={{ marginBottom: 8 }}>
                            <Space size={16}>
                              <Button type="text" onClick={this.exportExcelClick}><UploadOutlined /></Button>
                              <Dropdown
                                onOpenChange={(e) => { this.setState({ tableDropdownVisible: e }) }}
                                open={tableDropdownVisible}
                                dropdownRender={() => (
                                  <CheckboxGroup style={{ backgroundColor: "#fff", border: "1px solid #FAFAFA", padding: 16 }} onChange={this.tableColumnsChange} value={tableCheckColumes}>
                                    <Row style={{ width: 100 }}>
                                      {tableColumnTem?.map((itm: any) => (<Col key={itm.key} ><Checkbox value={itm.key}>{itm.title}</Checkbox></Col>))}
                                    </Row>
                                  </CheckboxGroup >
                                )}
                              >
                                <Button type="text"><SettingOutlined /></Button>
                              </Dropdown>

                            </Space>

                          </Col>
                        </Row>
                        <Table 
                          size="middle" 
                          columns={tableColumns.map((item)=>{ 
                            item.title = t(item.title)
                            return item 
                          })} 
                          dataSource={assetMonthDetailCalDtos}
                          locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        ></Table>
                      </Col>
                    </Row>
                  </Col>

                </Row>
              </Row>
            )}
          </div>
        )
      }}</Translation>

    )
  }
}
export default connect(mapStatetoProps, {})(AssetAllocation);
